import { getConfig } from '@/setting';

export function appCallBack(eventName, value) {
  let output = value || "";
  if (typeof output === "object") output = JSON.stringify(output);

  //android
  try {
    MobileAppInterface[eventName](output || undefined);
  }
  catch (ex) { }
  //flutter
  let flutter_trigger_flag = false;
  try {
    window[eventName].postMessage(output)
    flutter_trigger_flag = true;
  }
  catch (ex) {
  }
  //ios

  if (!flutter_trigger_flag) {
    try {
      window.webkit.messageHandlers[eventName].postMessage({ body: output });
    }
    catch (ex) { }
  }
}

export function appShowMessage(message = "", title = "") {
  //android
  try {
    MobileAppInterface.showMessage(message, title);
  }
  catch (ex) { }
  //flutter
  let flutter_trigger_flag = false;
  try {
    window.showMessage.postMessage(JSON.stringify({
      body: {
        title: title,
        message: message
      }
    }))
    flutter_trigger_flag = true;
  }
  catch (ex) { }
  //ios
  if (!flutter_trigger_flag) {
    try {
      window.webkit.messageHandlers.showMessage.postMessage({
        body: {
          title: title,
          message: message
        }
      });
    }
    catch (ex) { }
  }
}

export function isApp() {
  const ua = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua) ||
    (navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
  const isAndroid = /android/.test(ua) ||
    (navigator.userAgentData && navigator.userAgentData.platform === 'Android');

  return isIOS || isAndroid;
}

export function isIos() {
  const ua = window.navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod/.test(ua) ||
    (navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
}

export function appCallAlert(value = '') {
  if (BUILD_MODE === 'prd') return;

  appCallBack("onError", value);

  if (!isApp()) {
    console.log('[appCallAlert]: ', value)
  }
}

export function appCallPrintLog(message = '') {
  appCallBack("printLog", message);

  if (!isApp()) {
    console.log('[appCallPrintLog] ', message)
  }
}

// webView 開新分頁專用
// 效果相當於 App 套件內部自己管理 history 的 $router.push + App 會幫忙直接 Reload
// 用在 BackGestures 的頁面 preview 用
// export function appCallNavigate(context, message = '', query = {}, closePrev = true) {
//   // if (closePrev) {
//   //   appCallBack("onComplete", ''); //務必先關掉前一頁, 不要有多層
//   // }

//   let httpHost = 'https'
//   if (BUILD_MODE === 'dev') {
//     httpHost = 'http'
//   }

//   appCallBack("pushPage", `${httpHost}://${domain}${message}`);

//   if (!isApp()) {
//     context.$router.push({ path: message, query });
//   }
// }

// webView 關閉分頁專用
// export function appCallCloseWebView() {
//   appCallBack("onComplete", '')

//   if (!isApp()) {
//     window.close();
//   }
// }

export function appCallReadStorage(key = 'userInfo') {
  if (isApp()) {
    appCallBack("readUserInfo", key);
  } else {
    console.log('[appCallReadStorage] ', key);
  }
}

export function appCallSaveStorage({ key = 'userInfo', value = '' }) {
  const object = {
    key,
    value: JSON.stringify(value)
  }

  appCallBack("setUserInfo", object);

  if (!isApp()) {
    console.log('[appCallSaveStorage]: ', object)
  }
}

export function appCallRemoveStorage(key = 'userInfo') {
  const object = {
    key,
    value: '',
  }

  appCallBack("setUserInfo", object);

  if (!isApp()) {
    console.log('[appCallSaveStorage]: ', object)
  }
}